export default __webpack_public_path__ + "static/media/death.097ddec9.svg";